(function() {
  var is_touch_device = ("ontouchstart" in window) || (window.DocumentTouch && document instanceof DocumentTouch);
  var currentCards = [];
  var currentIdx = -1;

  // On touch devices, intercept clicks on any element with data-card-image.
  // Works on any page (spoilers, decklist, etc.) — no page-specific logic here.
  document.addEventListener('click', function(e) {
    if (!is_touch_device) return;
    var card = e.target.closest('[data-card-image]');
    if (!card) return;
    // Let unofficial-blocker dismissals and source links pass through normally
    if (e.target.closest('.spoiler-card-unofficial-blocker')) return;
    if (e.target.closest('.spoiler-card-source')) return;
    if (e.target.closest('.btn-toggle-dfc')) return;
    e.preventDefault();
    openCardModal(card);
  });

  // Walk up to the owning card collection, query all [data-card-image]
  // siblings, and filter to only those visible in the DOM.
  // el.offsetParent !== null is reliable regardless of how hiding is done
  // (MixItUp display:none, CSS classes, anything).
  function getVisibleCards(card) {
    var visualContainer = card.closest && card.closest('.deck-visual-container');
    if (visualContainer) {
      return Array.from(visualContainer.querySelectorAll('.deck-visual-card[data-card-image]'))
        .filter(function(el) { return el.offsetParent !== null; });
    }

    return Array.from(card.parentElement.querySelectorAll('[data-card-image]'))
      .filter(function(el) { return el.offsetParent !== null; });
  }

  function openCardModal(card) {
    var modalCard = card.closest && card.closest('.deck-visual-card[data-card-image]') || card;
    currentCards = getVisibleCards(modalCard);
    currentIdx = currentCards.indexOf(modalCard);
    populateModal(modalCard);
    bootstrap.Modal.getOrCreateInstance(document.querySelector('#card-popup-modal')).show();
  }

  function populateModal(card) {
    var qty = card.dataset.cardQuantity;
    var name = card.dataset.cardName;
    document.getElementById('card-popup-modal-title').textContent = qty ? (qty + 'x ' + name) : name;
    document.getElementById('card-popup-modal-image-container').innerHTML = modalImageHtml(card);
    var modalLink = document.getElementById('card-popup-modal-link');
    if (modalLink) modalLink.href = card.dataset.cardUrl;
    // Guard: modal body can be replaced externally, making these null.
    var prevBtn = document.getElementById('card-popover-prev-btn');
    var nextBtn = document.getElementById('card-popover-next-btn');
    if (prevBtn) prevBtn.classList.toggle('d-none', currentIdx === 0);
    if (nextBtn) nextBtn.classList.toggle('d-none', currentIdx === currentCards.length - 1);
  }

  function modalImageHtml(card) {
    var frontImage = escapeAttribute(card.dataset.cardImage);
    var backImage = escapeAttribute(card.dataset.cardImageBack);
    var frontName = escapeAttribute(card.dataset.cardName || 'Card front');
    var backName = escapeAttribute(card.dataset.cardNameBack || 'Card back');

    if (!backImage) {
      return "<img src=\"" + frontImage + "\" alt=\"" + frontName + "\" class=\"price-card-image-image\">";
    }

    return [
      "<div class=\"price-card-dfc\">",
        "<div class=\"price-card-dfc-inner\">",
          "<div class=\"price-card-dfc-spacer\"><img src=\"" + frontImage + "\" alt=\"\" class=\"price-card-image-image\"></div>",
          "<div class=\"price-card-dfc-front\"><img src=\"" + frontImage + "\" alt=\"" + frontName + "\" class=\"price-card-image-image\"></div>",
          "<div class=\"price-card-dfc-back\"><img src=\"" + backImage + "\" alt=\"" + backName + "\" class=\"price-card-image-image\"></div>",
        "</div>",
        "<button class=\"btn btn-toggle-dfc btn-secondary\" type=\"button\" data-bs-toggle=\"button\" aria-label=\"Flip card face\">",
          "<span class=\"fas fa-sync-alt\" aria-hidden=\"true\"></span>",
        "</button>",
      "</div>"
    ].join('');
  }

  function escapeAttribute(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function bindCardImageModalControls() {
    var prevBtn = document.getElementById('card-popover-prev-btn');
    var nextBtn = document.getElementById('card-popover-next-btn');
    var modal   = document.getElementById('card-popup-modal');
    if (!prevBtn || !nextBtn || !modal) return;

    prevBtn.addEventListener('click', function() {
      if (currentIdx > 0) { currentIdx--; populateModal(currentCards[currentIdx]); }
    });

    nextBtn.addEventListener('click', function() {
      if (currentIdx < currentCards.length - 1) { currentIdx++; populateModal(currentCards[currentIdx]); }
    });

    modal.addEventListener('hidden.bs.modal', function() {
      prevBtn.classList.add('d-none');
      nextBtn.classList.add('d-none');
      var imageContainer = document.getElementById('card-popup-modal-image-container');
      if (imageContainer) imageContainer.innerHTML = '';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCardImageModalControls, { once: true });
  } else {
    bindCardImageModalControls();
  }
})();
